(function () {
  function addSignupLink() {
    var loginLinks = document.querySelectorAll('.pr-login-cta');
    if (!loginLinks.length) return false;

    loginLinks.forEach(function (loginLink) {
      if (loginLink.dataset.prSignupAdded === 'true') return;
      loginLink.dataset.prSignupAdded = 'true';

      var signupLink = document.createElement('a');
      signupLink.href = '/account/register';
      signupLink.className = loginLink.className.replace('pr-login-cta', 'pr-signup-cta');
      signupLink.innerHTML = '<span class="icon__fallback-text"><button class="button signup_btn" type="button">Sign Up</button></span>';

      loginLink.parentNode.insertBefore(signupLink, loginLink.nextSibling);
    });

    return true;
  }

  if (!addSignupLink()) {
    document.addEventListener('DOMContentLoaded', addSignupLink);
  }
  window.addEventListener('load', addSignupLink);
})();
